import React from "react";
import Reflux from "reflux";
import GrComponentFactory from "../gr_component_factory";
import AuthorFollowStore from "../../react_stores/author_follow_store";
import { formatNumberWithDelimiter } from "../../modules/number_formatting_utils";

export default GrComponentFactory.createClass({
  displayName: "AuthorFollowCount",

  mixins: [Reflux.connectFilter(AuthorFollowStore, "authorFollowStore", function(follows) {
    return follows[this.props.authorId];
  })],

  propTypes: {
    authorId: React.PropTypes.number.isRequired,
    className: React.PropTypes.string,
  },

  render() {
    const count = this.state.authorFollowStore.followingCount;

    return (
      <div className={this.props.className}>
        {`${formatNumberWithDelimiter(count)} ${count === 1 ? "follower" : "followers"}`}
      </div>
    );
  },
});
